export default function usePurchaseOrder() {
    const getOrderObj = (sortName, sortOrder) => {
        if (sortName !== "" && sortOrder != "DEFAULT") {
            switch (sortName) {
                case "id":
                    return {
                        order: {
                            id: sortOrder,
                        },
                    };
                case "product.name":
                    return {
                        order: {
                            product:
                                { name: sortOrder }
                        },
                    };
                case "merchant.name":
                    return {
                        order: {
                            merchant: {
                                name: sortOrder,
                            },
                        }
                    };
                case "location.locationCode":
                    return {
                        order: {
                            location: {
                                locationCode: sortOrder,
                            },
                        }
                    };
                case "location.type":
                    return {
                        order: {
                            location: {
                                type: sortOrder,
                            },
                        }
                    };
                case "merchant.name":
                    return {
                        order: {
                            merchant: {
                                name: sortOrder,
                            },
                        }
                    };
                case "merchant.name":
                    return {
                        order: {
                            merchant: {
                                name: sortOrder,
                            },
                        }
                    };
                case "product.weightInGrams":
                    return {
                        order: {
                            product: {
                                weightInGrams: sortOrder,
                            },
                        }
                    };
                case "createdAt":
                    return {
                        order: {
                            createdAt: sortOrder,
                        }
                    };
                case "status":
                    return {
                        order: {
                            status: sortOrder
                        }
                    };
                case "merchant.name":
                    return {
                        order: {
                            merchant: {
                                name: sortOrder,
                            },
                        }
                    };

            }
        }
        else {
            return {
                order: [
                    {
                        id: "ASC",
                    },
                ],
            }

        }
    }

    const getFilterObj = (filters) => {
        let filterList = [
        ]

        if (filters?.productId != "all") {
            filterList.push({
                productId: {
                    eq: parseInt(filters.productId),
                },
            });
        }

        if (filters?.merchantId != "all") {
            filterList.push({
                merchantId: {
                    eq: parseInt(filters.merchantId),
                },
            });
        }

        if (filters?.locationId != "all") {
            filterList.push({
                locationId: {
                    eq: parseInt(filters.locationId),
                },
            });
        }
        if (filters?.locationType != "all") {
            filterList.push({
                location: {
                    type:
                    {
                        eq: filters.locationType,
                    }
                }
            });
        }

        if (filters?.status != "all") {
            filterList.push({
                status: {
                    eq: filters.status,
                }
            });
        }

        return {
            where: {
                and: [...filterList],
            }
        }
    }

    const getSearchObj = (search) => {

        let searchRes = { query: "" }
        if (search.trim() != "") {
            searchRes.query = search
        }
        return searchRes
    }
    return {
        getOrderObj,
        getFilterObj,
        getSearchObj
    };
}